module.exports = __webpack_public_path__ + "img/glassthicknessplus-16.b48dd50c.svg";